package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class OrderProfile(
    @SerialName("email") val email: String,
    @SerialName("firstName") val firstName: String,
    @SerialName("lastName") val lastName: String,
    @SerialName("defaultShippingAddress") val defaultShippingAddress: CartAddress?,
    @SerialName("orders") val orders: List<Order>,
)
